export default __webpack_public_path__ + "static/media/favicon.41fc31c5.ico";